export default "/images/ec812a5e271ed69fb6034c49d9970059.avif";